import { Header } from "../../components/Header";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import { Loading } from "../../components/Loading";
import { Table } from "antd";
import React from "react";
import NotificationsFilter from "./NotificationsFilter/NotificationsFilter";
// import PlateNumber from "../../components/PlateNumber";
import PlateNumberComponent from "../../components/PlateNumberComponent";
import Column from "antd/lib/table/Column";
import styles from "./Notification.module.css";

export const Notifications = () => {
  const notifications = {
    data: [],
  };

  return (
    <div className={styles.NotificationsTable}>
      <Header title="Notifications" activeItem="Notifications" />

      <ContentCard
        filter={<NotificationsFilter exportNotifications={() => {}} />}
      >
        <Loading isLoading={false}>
          <Table
            tableLayout="auto"
            size="middle"
            scroll={{ x: 1300 }}
            dataSource={notifications.data || []}
            pagination={{
              position: ["bottomCenter"],
              // current: notifications?.pagination.page,
              // pageSize: notifications?.pagination.limit,
              // total: notifications?.pagination.count,
              // onChange: changePage,
            }}
            showHeader={false}
          >
            <Column
              title="PlateNumber"
              dataIndex="plateNumber"
              key="plateNumber"
              render={(plateNumber) => (
                <div className={styles.PlateNumber}>
                  <div className={styles.BulletPoint} />
                  <PlateNumberComponent data={plateNumber} />
                </div>
              )}
            />
            <Column
              title="Text"
              dataIndex="text"
              key="text"
              render={(text) => <p>{text}</p>}
            />
          </Table>
        </Loading>
      </ContentCard>
    </div>
  );
};
